import { render, staticRenderFns } from "./DeclineOrder.vue?vue&type=template&id=15ccd72a&scoped=true&"
import script from "./DeclineOrder.vue?vue&type=script&lang=js&"
export * from "./DeclineOrder.vue?vue&type=script&lang=js&"
import style0 from "./DeclineOrder.vue?vue&type=style&index=0&id=15ccd72a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ccd72a",
  null
  
)

export default component.exports